import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../firebase.ts";
import { type Factoring } from "./factoringModel";

interface Request {
  page?: number;
  pageSize?: number;
}

interface Response {
  success: boolean;
  factoringList: Factoring[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
}

export const swrKey = "getFactoringList";

export const factoringListFetcher = async ([_key, page, pageSize]: [
  string,
  number,
  number,
]) => {
  const functions = getFirebaseFunctions();
  const getFactoringListFunction = httpsCallable<Request, Response, object>(
    functions,
    swrKey,
  );
  const res = await getFactoringListFunction({
    page,
    pageSize,
  });
  return res.data;
};
